import styled from "styled-components";

export const Main = styled.main`
  max-width: 75em;
  margin: 0px auto;
  padding: 0 ${({ theme }) => theme.spacing.sp16};
`;
